<div class="order-dialog" id="order_alert_popUp">
    <mat-toolbar class="heading_bkg_hgt">
        <div class="heading_block">
            <h2 class="class_txt">Manufacturer Order Alerts</h2>

            <img class="close_icon" (click)="OncloseManufacturerOrderPopup()"
                src="../../../../../../assets/images/close.svg" alt="close">
        </div>
    </mat-toolbar>
    <mat-dialog-content>
        <div class="md-dialog-content user-role-dialog-content padding_tl">

            <span class="content_txt">You have Manufacturer Order(s) that require your attention</span>
        </div>
    </mat-dialog-content>


    <mat-dialog-actions align="end" class="view_btn">
        <button class="prim-button-link" id="view_alert_btn" (click)="onViewClick()">VIEW ALERT</button>
    </mat-dialog-actions>
</div>
  
  